<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The River Below</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head"><em>A Selection of Recent Titles by Bonnie Hearn Hill</em></h3>
<p class="books-by-text-space-after"><em>The Kit Doyle mysteries</em></p>
<p class="books-by-text">IF ANYTHING SHOULD HAPPEN *</p>
<p class="books-by-text">GOODBYE FOREVER *</p>
<p class="books-by-text-space-after">I WISH YOU MISSED ME *</p>
<p> </p>
<p class="books-by-text-space-after"><em>The Star Crossed series</em></p>
<p class="books-by-text">ARIES RISING</p>
<p class="books-by-text">TAURUS EYES</p>
<p class="books-by-text-space-after">GEMINI NIGHT</p>
<p> </p>
<p class="books-by-text"><span class="small"><em>* available from Severn House</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?a5ef8e78